/* eslint-disable jsx-a11y/anchor-is-valid */
import {useState, useEffect} from 'react'
import { useNavigate,Navigate,useParams  } from "react-router-dom";
import {useAuth} from '../core/Auth'
import { GoogleLogin , GoogleLogout} from 'react-google-login'
import { gapi } from 'gapi-script'
import {Link} from 'react-router-dom'


export function RedirectPage() {
  const navigate = useNavigate();
  let { uid } = useParams();
  const [ profile, setProfile ] = useState<any>([]);
  const [loading, setLoading] = useState(false)
  const {saveAuth, setCurrentUser} = useAuth()



function setUID(){
    console.log("uid",uid)
    if(uid){
        localStorage.setItem('uid', uid);
    } else {
        localStorage.setItem('uid', '');
    }
}
 
  useEffect(() => {
    setUID()
    navigate('/auth/registration-page' )

    },[]);

   


 
  return (
   <></>
  )
}

